Wee.fn.make('navigation', {
	init: function() {
		var priv = this.$private,
			$nav = $('ref:navigation'),
			$contact = $('ref:headerContact'),
			$desktopItem = $('ref:desktopItem'),
			$footerToggle = $('.js-footer-toggle');

		$.screen.map([
			{
				max: 2,
				init: false,
				callback: function() {
					priv.moveNavBlocksMobile();

					$('ref:searchForm').insertAfter($('ref:search'));

					$footerToggle.hide();
				}
			},
			{
				max: 2,
				callback: function() {
					$.events.off(false, '.tablet');
					$.events.off(false, '.menu');

					$nav.insertAfter($('ref:siteWrapper'));
					$contact.insertAfter($('ref:navLinks'));

					priv.initMobileMenu();
					priv.initAccordion();
					priv.disableButton();
				}
			},
			{
				min: 3,
				callback: function() {
					$nav.insertBefore($('ref:carts'));

					$contact.insertBefore($('ref:siteHeader'));

					$('ref:searchForm').insertAfter($nav);

					priv.destroyMobileMenu();

					priv.moveNavBlocksTablet();
					priv.toggleNavBlocks();

					priv.searchToggle();

					priv.sticky();

					$footerToggle.show();
				}
			},
			{
				max: 3,
				init: false,
				callback: function() {
					$desktopItem.insertAfter($('ref:desktopAfter'));
				}
			},
			{
				min: 4,
				callback: function() {
					$('ref:desktopList').append($desktopItem);
				}
			}
		]);

		priv.bindSearch();
	},
	unloadSearch: function() {
		if ($.routes.uri().path != '/search-results') {
			this.$private.disableSearchForm();
		}
	}
}, {
	/**
	 * Move navigation blocks in DOM
	 *
	 * @private
	 */
	moveNavBlocksMobile: function() {
		$('ref:navBlock').each(function(el) {
			var $el = $(el);

			$el.insertAfter($el.data('parent'));
		});
	},
	moveNavBlocksTablet: function() {
		$('ref:navBlock').insertAfter($('ref:navWrapper'));
	},

	/**
	 * Crop or uncrop body
	 *
	 * @private
	 */
	cropBody: function() {
		$($._body).addClass('-crop');
	},
	uncropBody: function() {
		$($._body).removeClass('-crop');
	},

	/**
	 * Init mobile menu
	 *
	 * @private
	 */
	initMobileMenu: function() {
		var scope = this;

		this.closeAccordions();

		$.events.on({
			'ref:navOpen': {
				click: function() {
					scope.openMobileMenu();
				}
			},
			'ref:navClose': {
				click: function() {
					scope.closeMobileMenu();
				}
			}
		}, {
			namespace: 'mobile'
		});

		$('ref:menuWrapper').find('a')
			.not('[data-static]')
			.on('click.mobile', function() {
				scope.closeMobileMenu();
			});
	},

	/**
	 * Destroy mobile menu
	 *
	 * @private
	 */
	destroyMobileMenu: function() {
		$.events.off(false, '.mobile');

		$('ref:accordionList').show();

		$('ref:accordionToggle').add($('ref:siteWrapper'))
			.add($('ref:navigation'))
			.add($('ref:searchForm'))
			.add($('ref:search'))
			.deActivate();

		this.uncropBody();
	},

	/**
	 * Open mobile menu
	 *
	 * @private
	 */
	openMobileMenu: function() {
		$('ref:siteWrapper, ref:navigation').activate();

		this.cropBody();
	},

	/**
	 * Close mobile menu
	 *
	 * @private
	 */
	closeMobileMenu: function() {
		$('ref:siteWrapper, ref:navigation').deActivate();

		this.closeAccordions();

		this.uncropBody();
	},

	/**
	 * Click event to fire panel toggling
	 *
	 * @private
	 */
	initAccordion: function() {
		$('ref:caratToggle').on('click.mobile', function(e, el) {
			var $el = $(el);

			$el.toggleClass('-is-open');

			$('.js-foldable', $el.closest('.js-cat')).first().activate().toggle();
		});

		$('ref:accordionToggle').on('click.mobile', function(e) {
			var $this = $(this);

			if (! $this.hasClass('-is-active')) {
				$this.activate()
					.next()
					.activate()
					.show();
			} else {
				$this.deActivate()
					.next()
					.deActivate()
					.hide();
			}

			e.preventDefault();
		});
	},

	/**
	 * Close accordions
	 *
	 * @private
	 */
	closeAccordions: function() {
		$('ref:accordionToggle').deActivate()
			.next()
			.deActivate()
			.hide();
	},

	/**
	 * Disable clear button on search form
	 *
	 * @private
	 */
	disableButton: function() {
		var $input = $('ref:searchInput'),
			$btn = $('ref:clearBtn');

		$.events.on({
			'ref:searchInput': {
				keyup: function() {
					if ($input.val().length) {
						$btn.prop('disabled', false);
					} else {
						$btn.prop('disabled', true);
					}
				}
			},
			'ref:clearBtn': {
				'click.clear': function() {
					if ($input.val().length > 0) {
						setTimeout(function() {
							$btn.prop('disabled', true);
						}, 100);
					}
				}
			}
		});
	},

	/**
	 * Bind site search
	 *
	 * @private
	 */
	bindSearch: function() {
		$('ref:searchFormSubmit').on('submit', function(e) {
			var $container = $('ref:searchForm'),
				keywords = $('ref:searchInput').val();

			$container.addClass('-is-loading');

			$.fetch.request({
				url: 'ajax/search-results?keywords=' + keywords,
				json: true,
				success: function(response) {
					var channels = response.channels,
						results = response.results,
						channel;

					// Are there any results?
					if (Math.max.apply(null, results)) {
						for (var i in results) {
							if (results.hasOwnProperty(i) && results[i] > 0) {
								channel = channels[i];

								break;
							}
						}
					} else {
						channel = channels[0];
					}

					// $.history.go({
					// 	path: '/search-results?keywords=' + keywords + '&channel=' + channel,
					// 	request: {
					// 		complete: function() {
					// 			$container.removeClass('-is-loading');
					// 		}
					// 	}
					// });

					window.location = "/search-results?keywords=" + keywords + "&channel=" + channel;
				}
			});

			if ($.screen.size() <= 2) {
				$('ref:siteWrapper, ref:navigation').deActivate();
			}

			e.preventDefault();
		});
	},

	/**
	 * Click event to show/hide search form
	 *
	 * @private
	 */
	searchToggle: function() {
		$('ref:navigation').on('click.search, keyup.search', function(e) {
			var $target = $(e.target);

			if (e.type == 'keyup' && e.which != 13) {
				return;
			}

			if ($target.hasClass('site-nav') || $target.hasClass('site-nav__search-toggle')) {
				$('ref:search').hasClass('-is-active') ? this.disableSearchForm() : this.enableSearchForm();
			} else {
				this.disableSearchForm();
			}
		}, {
			scope: this
		});
	},

	/**
	 * Enable search form
	 *
	 * @private
	 */
	enableSearchForm: function() {
		$('ref:search, ref:searchForm').activate();

		setTimeout(function() {
			$('ref:searchInput')[0].focus();
		}, 100);
	},

	/**
	 * Disable search form
	 *
	 * @private
	 */
	disableSearchForm: function() {
		$('ref:search, ref:searchForm').deActivate();

		$('ref:searchInput').val('');
	},

	/**
	 * Init navigation blocks on tablet
	 *
	 * @private
	 */
	toggleNavBlocks: function() {
		var scope = this,
			$navBlockToggle = $('ref:navBlockToggle'),
			$header = $('ref:siteHeader'),
			$win = $($._win),
			openClass = '-is-open';

		$('ref:siteNavSubcatToggle').on('click.tablet', function(e) {
			$.history.go({
				path: $(this).attr('href')
			});

			e.preventDefault();
		});

		$('ref:menuTab').on('mouseenter', function() {
			$('ref:navBlock').removeClass('-is-open');
			$('ref:navBlockToggle').removeClass('-is-active');
		});

		$navBlockToggle.on('mouseover.tablet', function(e, el) {
			var $el = $(el),
				$body = $($._body),
				$anchorHeight = $header.height(),
				$nav = $el.ariaControls(),
				isScrolled = '-is-scrolled';

			scope.currentNavBlockToggle = $el;

			if (e.type === 'keyup' && e.which !== 13) {
				return;
			}

			$body.off('.menu');

			var scrollTop = $win.scrollTop();

			$navBlockToggle.filter('.-is-active')
				.deActivate()
				.each(function(el) {
					$(el).ariaControls().removeClass(openClass);
				});

			$el.activate().ariaControls().addClass(openClass);

			if ($win.height() < ($anchorHeight + $nav.height()) + scrollTop) {
				var top = scrollTop + Math.abs(scrollTop - $header.offset().top);

				$header.css('top', top + 'px')
					.addClass(isScrolled);
			}

			$win.on('scroll.nav', function() {
				if ($win.scrollTop() < scrollTop) {
					$header.removeClass(isScrolled)
						.css('top', '');
					$nav.deActivate().removeClass(openClass);
					$navBlockToggle.deActivate();
					$win.off('.nav');
				}
			});

			$body.on({
				'click.menu': function(e) {
					if (e.target !== $el.ariaControls()[0] && e.target.nodeName !== 'SPAN') {
						scope.closeNav($el);
					}
				},
				'keyup.menu': function(e) {
					if (e.which === 27) {
						scope.closeNav($el);
					}
				}
			});

			e.stopPropagation();
		});

		$('ref:navBlock').on('mouseleave', function() {
			scope.closeNav(scope.currentNavBlockToggle);
		});
	},

	closeNav: function($el) {
		var $header = $('ref:siteHeader');

		$el.deActivate().ariaControls().removeClass('-is-open');
		$header.removeClass('-is-scrolled').css('top', '');
		$($._win).off('.nav');
	},

	/**
	 * Initiate the sticky header class toggle on scroll
	 *
	 * @private
	 */
	sticky: function() {
		var $win = $($._win),
			$header = $('ref:siteHeader'),
			$contact = $('ref:headerContact'),
			sticky = '-is-sticky',
			scrolled = false;

		$win.on('scroll', function() {
			var scrollTop = $win.scrollTop(),
				$anchorHeight = $contact.height(),
				anchorOffset = $contact.offset().top + $anchorHeight;

			if (! scrolled && scrollTop > anchorOffset) {
				$header.addClass(sticky);

				scrolled = true;
			} else if (scrolled && scrollTop <= anchorOffset) {
				$header.removeClass(sticky);

				scrolled = false;
			}
		});
	}
});